const logout = ({ next }) => {
  localStorage.removeItem('token')
  localStorage.removeItem('withEndCustomers')
  sessionStorage.removeItem('currentCompanySlug')
  sessionStorage.removeItem('userRequestUrl')
  sessionStorage.removeItem('automations')
  sessionStorage.removeItem('validations')
  window.$chatwoot?.reset()
  return next({ name: 'login' })
}

export default logout
